import { render, staticRenderFns } from "./SharedNotifications.vue?vue&type=template&id=654a76e6&scoped=true&"
import script from "./SharedNotifications.vue?vue&type=script&lang=js&"
export * from "./SharedNotifications.vue?vue&type=script&lang=js&"
import style0 from "./SharedNotifications.vue?vue&type=style&index=0&id=654a76e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../CommunityWebPortal/_app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "654a76e6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/sapphire/K12Live16/build/CommunityWebPortal/_app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('654a76e6')) {
      api.createRecord('654a76e6', component.options)
    } else {
      api.reload('654a76e6', component.options)
    }
    module.hot.accept("./SharedNotifications.vue?vue&type=template&id=654a76e6&scoped=true&", function () {
      api.rerender('654a76e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "VueCommon/common-components/src/components/AccontSettings/SharedNotifications.vue"
export default component.exports